"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VitalsRecordType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var VitalsRecordType_Factory = /** @class */ (function () {
    function VitalsRecordType_Factory() {
    }
    VitalsRecordType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    VitalsRecordType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return VitalsRecordType_Factory;
}());
exports.VitalsRecordType_Factory = VitalsRecordType_Factory;
